import { UpdateUserDetails } from '../../api';
import { DeviceToken, User, UserDetails } from '../../types/User';
import { DefaultValues, FormState } from 'react-hook-form';
import { UserDrawerFormValues } from '../../types/forms';
import { getDateDiffFromNow } from '../../../../utils/dates';
import { ACTIVE_TOKEN_LAST_USED_MONTHS_THRESHOLD } from './consts';
import { TokenState } from './types';
import { UserEmailType } from '../SendEnrollmentRequest/types';

export const getUserDrawerFormInitialValuesFromUserDetails = (user: User): DefaultValues<UserDrawerFormValues> => {
    return {
        tokenLimit: user.tokenLimit,
        email: user.email,
        emailType: user.isManualEmail ? UserEmailType.CUSTOM : UserEmailType.AD,
        isExternalEmail: user.isExternalEmail
    };
};

const getUserDetailsEmail = ({ emailType, email }: UserDrawerFormValues, { adEmail }: User): UserDetails['email'] => {
    if (emailType === UserEmailType.AD) {
        return adEmail || '';
    }

    return email;
};

export const getUpdateUserDetails = (formValues: UserDrawerFormValues, user: User, dirtyFields: FormState<UserDrawerFormValues>['dirtyFields']): UpdateUserDetails => {
    const updateUserDetails: UpdateUserDetails = {};
    for (const key in dirtyFields) {
        if (key === 'email') {
            updateUserDetails.email = getUserDetailsEmail(formValues, user);
        } else if (key === 'emailType') {
            updateUserDetails.isManualEmail = formValues.emailType === UserEmailType.CUSTOM;
        } else {
            updateUserDetails[key] = formValues[key];
        }
    }
    return updateUserDetails; 
};

const isActiveToken = ({ lastUsed }: DeviceToken): boolean =>
    !!lastUsed && getDateDiffFromNow(lastUsed, 'months') <= ACTIVE_TOKEN_LAST_USED_MONTHS_THRESHOLD;

const isUnusedToken = ({ lastUsed }: DeviceToken): boolean =>
    !lastUsed || getDateDiffFromNow(lastUsed, 'months') > ACTIVE_TOKEN_LAST_USED_MONTHS_THRESHOLD;

// todo: implement when implementing the relevant tikcet
const isDisabledToken = (token: DeviceToken): boolean => false;

export const getTokensPerState = (tokens: DeviceToken[]): Record<TokenState, DeviceToken[]> => {
    const tokensPerState: Record<TokenState, DeviceToken[]> = {
        [TokenState.ACTIVE]: [],
        [TokenState.UNUSED]: [],
        [TokenState.DISABLED]: []
    };

    for (const token of tokens) {
        if (isActiveToken(token)) {
            tokensPerState[TokenState.ACTIVE].push(token);
        } else if (isUnusedToken(token)) {
            tokensPerState[TokenState.UNUSED].push(token);
        } else if (isDisabledToken(token)) {
            tokensPerState[TokenState.DISABLED].push(token);
        }
    }

    return tokensPerState;
};
